export default __webpack_public_path__ + "static/Product-Research-1feed98ea74c2ddd383169faa73ca19d.webp";